import { StyledBetaChip } from './BetaChip.styles';

export const BetaChip: React.FC = () => {
  return <StyledBetaChip size={'small'} label={'Beta'} />;
};
